const getNumber = (s: string | number) => (typeof s === 'string' ? parseFloat(s.replace(/[^\d.]/g, '')) : s);

export default getNumber;
